import type { FC, PropsWithChildren } from "react";

import classnames from "classnames";

import styles from "./ProductDetailsCtaLayout.module.scss";

type ProductDetailsCtaLayoutProps = PropsWithChildren<{
  mobileCtaContent?: React.ReactNode;
}>;

export const ProductDetailsCtaLayout: FC<ProductDetailsCtaLayoutProps> = ({ mobileCtaContent, children }) => (
  <div className={classnames(["js-productDetails__ctaContainer", styles.container])}>
    {!!mobileCtaContent && <div className={styles.mobileCtaContent}>{mobileCtaContent}</div>}

    <div className={styles.addProductButtonWrapperRow}>{children}</div>
  </div>
);
